import React from "react";
import { Box, Typography } from "@mui/material";
import InboxOutlinedIcon from "@mui/icons-material/InboxOutlined";

/** Empty inventory for products that support listing but have no sites. */
const SitesEmptyState = ({ productLabel }) => (
  <Box
    display="flex"
    flexDirection="column"
    alignItems="center"
    justifyContent="center"
    py={8}
    px={2}
    textAlign="center"
  >
    <InboxOutlinedIcon color="disabled" sx={{ fontSize: 48, mb: 2 }} />
    <Typography variant="h5" color="textPrimary" gutterBottom>
      No on-demand sites
    </Typography>
    <Typography variant="body2" color="textSecondary" sx={{ maxWidth: 420 }}>
      No sites found for {productLabel}. Create one with New On-Demand Site.
    </Typography>
  </Box>
);

export default SitesEmptyState;
